var map = {
	"./home/home.module": [
		"./src/app/routes/home/home.module.ts",
		"home-home-module"
	],
	"./questionnaire-result/questionnaire-result.module": [
		"./src/app/routes/questionnaire-result/questionnaire-result.module.ts"
	],
	"./questionnaire-template/questionnaire-template.module": [
		"./src/app/routes/questionnaire-template/questionnaire-template.module.ts",
		"default~questionnaire-questionnaire-module~questionnaire-template-questionnaire-template-module",
		"questionnaire-template-questionnaire-template-module"
	],
	"./questionnaire/questionnaire.module": [
		"./src/app/routes/questionnaire/questionnaire.module.ts",
		"default~questionnaire-questionnaire-module~questionnaire-template-questionnaire-template-module",
		"questionnaire-questionnaire-module"
	],
	"./user/user.module": [
		"./src/app/routes/user/user.module.ts",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;